/* eslint default-param-last: 0 */
import reduxReducerHelper from '../../utils/reduxReducerHelperUtils';
import { AUTH_USER_SESSION_TOKEN_ACTIONS } from '../../utils/loginUtils';

const INIT_STATE = {
    [AUTH_USER_SESSION_TOKEN_ACTIONS.sessionPopupLastDisplayTime]: 0,
};

export default reduxReducerHelper(AUTH_USER_SESSION_TOKEN_ACTIONS, INIT_STATE);
